import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { accountLanguageSchema } from '../schemas/account-language.schema';

/**
 * Get information about the Language the account is using
 * @returns language the account is using
 */
export function getPreferencesAccountLanguage(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        accountsEnvironment.resolve(this).preferencesAccountLanguageUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(accountLanguageSchema));
}
